/**
 * Lennon — wordmark-only logo.
 * LENNON + division subtitle. Horizontal = "Management" (nav),
 * Stacked = "Creator Management + Global Creator Partnerships" (marketing surfaces).
 */
export default function LennonLogo({
  variant = "horizontal", // 'horizontal' | 'stacked' | 'wordmark-only'
  size = "md", // 'sm' | 'md' | 'lg'
  className = "",
}) {
  const sizes = {
    sm: { word: "text-lg", tag: "text-[10px]" },
    md: { word: "text-2xl", tag: "text-[10px]" },
    lg: { word: "text-5xl", tag: "text-xs" },
  };
  const s = sizes[size];

  if (variant === "stacked") {
    return (
      <div className={`inline-flex flex-col items-start gap-1.5 ${className}`}>
        <span className={`wordmark ${s.word} leading-none text-ink`}>LENNON</span>
        <span className={`font-sans ${s.tag} uppercase tracking-[0.22em] text-warm-600 leading-none`}>
          Creator Management + Global Creator Partnerships
        </span>
      </div>
    );
  }

  if (variant === "wordmark-only") {
    return (
      <span className={`wordmark ${s.word} text-ink ${className}`}>LENNON</span>
    );
  }

  // horizontal — wordmark with subtitle to the right (default for nav)
  return (
    <div className={`inline-flex items-baseline gap-3 ${className}`}>
      <span className={`wordmark ${s.word} leading-none text-ink`}>LENNON</span>
      <span className={`font-sans ${s.tag} uppercase tracking-[0.22em] text-warm-600 leading-none hidden sm:inline`}>
        Management
      </span>
    </div>
  );
}
